var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkCircle = function SvgCheckmarkCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m4.707 7.707-5 5a.99.99 0 0 1-.71.294 1 1 0 0 1-.711-.294l-2.5-2.5a1 1 0 0 1-.293-.71 1 1 0 0 1 .293-.711 1 1 0 0 1 .71-.293 1 1 0 0 1 .71.293l1.79 1.8 4.29-4.293A1 1 0 0 1 16.7 9.707z"
  })));
};
export default SvgCheckmarkCircle;